import { Codec, GetInterface, array } from 'purify-ts/Codec';
import { Either, Right, Left } from 'purify-ts/Either';
import * as R from 'remeda';

const roadCategoriesShortName = 'ERFKPS';
const roadStatuses = 'VAPF';
const roadsystemPattern = '[' + roadCategoriesShortName + '][' + roadStatuses + ']?(\\d+)?';
const roadUserGroupPattern = '((K|G))?';
const sectionPartPattern = '((S\\d+)(-\\d+)?)?((D\\d+)(-\\d+)?)?';
const meterPattern = '((M\\d+)(-\\d+)?)?';
const sectionMeterPattern = 'M\\d+';
const intersectionPartPattern = '((KD\\d+)(-\\d+)?)?';
const sideareaPartPattern = '((SD\\d+)(-\\d+)?)?';

const sectionPattern = `^(${roadsystemPattern}${roadUserGroupPattern}${sectionPartPattern}${meterPattern}$)`;
const intersectionPattern = `^(${roadsystemPattern}${roadUserGroupPattern}${sectionPartPattern}(${sectionMeterPattern}|KS\\d+)${intersectionPartPattern}${meterPattern}$)`;
const sideareaPattern = `^(${roadsystemPattern}${roadUserGroupPattern}${sectionPartPattern}(${sectionMeterPattern}|SA\\d+)${sideareaPartPattern}${meterPattern}$)`;

const regexpForShortRoadsysref_section = new RegExp(sectionPattern, 'i');
const regexpForShortRoadsysref_intersection = new RegExp(intersectionPattern, 'i');
const regexpForShortRoadsysref_sidearea = new RegExp(sideareaPattern, 'i');

const vegsystem = Codec.custom<string>({
  decode: value => {
    const typeCheckedString: Either<string, string> =
      typeof value === 'string' ? Right(value) : Left('Ugyldig vegsystem referanse: Ikke en tekststreng');

    const failure = `${typeCheckedString.extract()} er en ugyldig vegsystemreferanse`;

    const decodeResult = typeCheckedString.chain(val => {
      // Valid if the string passes any of the tests
      const valid = R.anyPass(val, [
        str => str.length === 1 && roadCategoriesShortName.includes(str),
        str => str.length === 0,
        str => regexpForShortRoadsysref_section.test(str),
        str => regexpForShortRoadsysref_intersection.test(str),
        str => regexpForShortRoadsysref_sidearea.test(str),
      ]);
      return valid ? Right(val) : Left(failure);
    });

    return decodeResult;
  },
  encode: value => value,
});

export const VegSystem = array(vegsystem);
export type VegSystem = GetInterface<typeof VegSystem>;
